import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { initializePerformanceMonitoring } from './utils/performance';
import { initializeErrorHandling } from './utils/errorHandling';

// Initialize monitoring systems
initializePerformanceMonitoring();
initializeErrorHandling();
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
